import { makeStyles } from '@material-ui/core'
import React, { ChangeEvent } from 'react'
import { PopUpForm } from '../../Component/PopUp'
import { BonusIncidentForm } from './BonusIncidentForm'

const useStyles = makeStyles(() => ({
  popup: {
    '& .MuiDialog-paper': {
      width: 750,
      maxWidth: 750
    }
  },
  button: {
    margin: 8
  }
}))

export interface BonusIncidentFormState {
  description: string
}

export interface BonusIncidentPopupProps {
  form: BonusIncidentFormState
  open: boolean
  onChange: (form: BonusIncidentFormState) => void
  onValidate: (form: BonusIncidentFormState) => void
  onCancel: (event: ChangeEvent<{}>) => void

  className?: string
  style?: React.CSSProperties
}

export const BonusIncidentPopup = (props: BonusIncidentPopupProps) => {
  const { form, open, className, onChange, onValidate, onCancel } = props

  const classes = useStyles()
  return (
    <PopUpForm
      title='Déclarer un incident'
      form={form}
      onValidate={onValidate}
      onCancel={onCancel}
      open={open}
      className={`${classes.popup} ${className || ''}`}
    >
      <BonusIncidentForm form={form} onChange={onChange} />
    </PopUpForm>
  )
}
